import { RecordingIntegrations } from '../Common/Constants/Recordings'

export enum AddUserModalID {
    USER_DETAILS,
    PERMISSIONS,
    EXTENSION_ENDPOINT,
    ROLE,
    REPORTING,
    SETTINGS,
    API_KEYS
}

export enum CustomiseRoleTabIDs {
    ADMINISTRATE,
    STATUS_TOOLS,
    ACTIONS
}

export const ADMIN_USERNAME: string = 'Admin'

export const LANGUAGE_DEFAULT: string = 'en_GB'

export const AKIXI_CME_NAME: string = 'Akixi'
export const DEFAULT_CME_ID: string = 'd6d6c5a5f0f90d60:-15617a00:169f533f6d5:5613'

export const SERVER_ALL_VALUE: string = 'All'
export const SERVER_NONE_VALUE: string = 'None'
export const SERVER_UNKNOWN_VALUE: string = 'Unknown'

/**
 * The extension endpoint fields a licence device-link validation rule can be bound to. CXS Agent validation
 * surfaces on either field; CXR User validation surfaces only on the device field.
 */
export const ENDPOINT_FIELD_KIND = {
    DEVICE: 'device',
    AGENT: 'agent'
} as const

/** Which endpoint field a validation rule instance is bound to (see {@link ENDPOINT_FIELD_KIND}). */
export type EndpointFieldKind = (typeof ENDPOINT_FIELD_KIND)[keyof typeof ENDPOINT_FIELD_KIND]
export const SERVER_NONE_CRI: string = RecordingIntegrations.NONE
export const NONE_SELECT: string = '[None Selected]'

export const REPORTS_READONLY: string = 'Report|Read'
export const REPORTS_UPDATE: string = 'Report|Update'
export const REPORTS_CREATE: string = 'Report|Create'
export const REPORTS_DELETE: string = 'Report|Delete'
export const REPORT_EDIT_PERMS: string[] = [REPORTS_CREATE, REPORTS_DELETE, REPORTS_UPDATE]

export const INFINITY: string = 'Infinity'
export const NEVER: string = 'Never'
